import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import authReducer from '../reducers/authReducer';
import { composeWithDevTools } from 'redux-devtools-extension';
import logger from 'redux-logger';

const middleWares = [thunk];

const composeEnhancers =
	process.env.NODE_ENV !== 'production'
		? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
		: compose;

// Remove logger plugin from production built
if (process.env.NODE_ENV === 'development') {
	middleWares.push(logger);
}

const appReducer = combineReducers({
	auth: authReducer
}, composeWithDevTools());

let store = () => {
	const store = createStore(
		appReducer,
		composeEnhancers(applyMiddleware(...middleWares))
	);

	return store;
};

export default store;

